<div class="div-action-top">
  <div>
    <div class="d-flex flex-wrap">
      <nz-form-item class="spacepad">
        <nz-form-control>
          <input [(ngModel)]="filter.sid" nz-input placeholder="SID" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-select
            nzMode="multiple"
            style="min-width: 220px"
            nzShowSearch
            nzAllowClear
            [nzDropdownStyle]="{ 'min-width': '280px' }"
            nzPlaceHolder="Chọn đối tác"
            [(ngModel)]="filter.partnerIds">
            <nz-option
              *ngFor="let item of partners"
              [nzValue]="item.id"
              [nzLabel]="item.code + ' - ' + item.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-date-picker style="width: 100%" [(ngModel)]="filter.fromDate" nzPlaceHolder="Từ ngày..." [nzFormat]="dateFormat">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-date-picker style="width: 100%" [(ngModel)]="filter.toDate" nzPlaceHolder="Đến ngày..." [nzFormat]="dateFormat"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="spacepad">
        <nz-form-control>
          <button nz-button class="mgr10" nzType="primary" nzSize="default" (click)="doSearch()">
            <span class="fa fa-fw fa-search"></span>
          </button>
          <button nz-button class="mgr15" nzType="dashed" nzSize="default" (click)="clearSearch()">
            <span class="fa fa-fw fa-times"></span>
          </button>
          <button nz-button class="mgr10" nzType="primary" nzSize="default" class="btn-green"
                  (click)="exportData()">
            <span class="fa fa-fw fa-file-excel"></span>
            Xuất Excel
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</div>
<div class="data-table">
  <dx-data-grid
    id="gridContainer"
    [dataSource]="dataSource"
    [remoteOperations]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [width]="'100%'"
    [height]="dxGridHeight"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [allowColumnResizing]="true"
    columnResizingMode="widget"
    [columnMinWidth]="50"
    [columnAutoWidth]="true"
  >
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-sorting mode="none"></dxo-sorting>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-paging [pageSize]="defaultPageSize || 20" [pageIndex]="0"></dxo-paging>
    <dxo-pager
      [visible]="true"
      [displayMode]="'full'"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [showInfo]="true"
      [showNavigationButtons]="true"
    ></dxo-pager>

    <dxi-column caption="Ngày gửi" [width]="140" dataField="dateSend" dataType="date" format="HH:mm dd/MM/yyyy"></dxi-column>
    <dxi-column caption="SID" dataField="orderCode" [width]="100"></dxi-column>
    <dxi-column caption="SĐT" dataField="phoneNo" [width]="120"></dxi-column>
    <dxi-column caption="Người gửi" dataField="userSend" [width]="130"></dxi-column>
    <dxi-column caption="Loại gửi" dataField="autoSend" [width]="110" cellTemplate="cellAutoSend"></dxi-column>
    <dxi-column caption="Trạng thái" dataField="statusText" [width]="130" cellTemplate="cellStatus"></dxi-column>
    <dxi-column caption="Lý do lỗi" dataField="errorMessage"></dxi-column>
    <dxi-column caption="Action" cellTemplate="cellAction" [width]="110" [allowFiltering]="false" [allowSorting]="false" cssClass="text-center"></dxi-column>

    <div *dxTemplate="let item of 'cellAutoSend'">
      {{ item.data.autoSend ? 'Tự động' : 'Thủ công' }}
    </div>
    <div *dxTemplate="let item of 'cellStatus'">
      <span [class]="item.data.statusSuccess ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">
        {{ item.data.statusText }}
      </span>
    </div>
    <div *dxTemplate="let item of 'cellAction'">
      <button nz-button nzSize="small" nzType="default" title="Xem chi tiết" (click)="showDetail(item.data)">
        <span class="fa fa-fw fa-eye"></span>
      </button>
    </div>
  </dx-data-grid>
</div>

<nz-modal
    nzTitle="Chi tiết gửi Zalo"
    [nzWidth]="700"
    [(nzVisible)]="isVisibleDetail"
    (nzOnCancel)="closeDetail()"
    [nzFooter]="null"
>
  <ng-container *nzModalContent>
    <div class="detail-row"><b>Thời gian gửi:</b> {{ selectedLog?.dateSend | date: 'HH:mm dd/MM/yyyy' }}</div>
    <div class="detail-row"><b>SID:</b> {{ selectedLog?.orderCode }}</div>
    <div class="detail-row"><b>SĐT:</b> {{ selectedLog?.phoneNo }}</div>
    <div class="detail-row"><b>Người gửi:</b> {{ selectedLog?.userSend }}</div>
    <div class="detail-row">
      <b>Trạng thái:</b>
      <span [class]="selectedLog?.statusSuccess ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">
        {{ selectedLog?.statusText }}
      </span>
      <span *ngIf="selectedLog?.errorMessage"> - {{ selectedLog?.errorMessage }}</span>
    </div>
    <div class="detail-row"><b>Request:</b></div>
    <pre class="detail-content">{{ prettyJson(selectedLog?.zaloRequest) }}</pre>
    <div class="detail-row"><b>Response:</b></div>
    <pre class="detail-content">{{ prettyJson(selectedLog?.zaloResponse) }}</pre>
  </ng-container>
</nz-modal>
